/* hs-eslint ignored failing-rules */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formGuid", "onDismissOtherPagesWarning", "onClose", "onClone", "onFormChange"];
import { connect } from 'react-redux';
import PagesModal from './PagesModal';
import * as formsSelectors from 'ContentData/selectors/forms';
import * as FormActions from 'ContentData/actions/Forms';
import { jsx as _jsx } from "react/jsx-runtime";
const PagesModalContainer = props => {
  const {
      formGuid,
      onDismissOtherPagesWarning,
      onClose = () => {},
      onClone,
      onFormChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleOnClose = (...args) => {
    onDismissOtherPagesWarning(...args);
    onClose(...args);
  };
  const cloneForm = () => {
    onClone(formGuid).then(({
      guid
    }) => {
      onFormChange({
        target: {
          value: guid
        }
      });
    }).catch(err => console.error(err)).finally(() => {
      handleOnClose();
    });
  };
  return /*#__PURE__*/_jsx(PagesModal, Object.assign({
    onClose: handleOnClose,
    onCloneForm: cloneForm
  }, rest));
};
const mapStateToProps = (state, props) => ({
  pages: formsSelectors.getParentPages(state, props.formGuid)
});
const mapDispatchToProps = {
  onDismissOtherPagesWarning: FormActions.onDismissOtherPagesWarning,
  onClone: FormActions.cloneForm
};
export default connect(mapStateToProps, mapDispatchToProps)(PagesModalContainer);